import { gql } from '@apollo/client';

export default gql`
  mutation openTask($_id: String) {
    openTask(_id: $_id) {
      ok
      message
      error
    }
  }
`;
